'use strict';

require('whatwg-fetch');
require('promise-polyfill/lib/polyfill');
require('core-js/fn/array/find');
require('core-js/fn/array/find-index');
require('core-js/fn/object/assign');
require('core-js/fn/string/starts-with');
require('core-js/fn/string/repeat');
require('core-js/fn/symbol');
require('core-js/fn/symbol/iterator');

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/dist/index.cjs.js
// module id = 679
// module chunks = 0